import React from 'react';
import { Navigation } from '../components/Navigation';
import { TeamSection } from '../components/TeamSection';
import { Footer } from '../components/Footer';
export function TeamPage() {
  return <div className="min-h-screen bg-[#0f2424] text-white selection:bg-[#4fd1c5] selection:text-[#0f2424]" data-id="element-297">
      <Navigation data-id="element-298" />
      <main className="pt-20" data-id="element-299">
        <TeamSection data-id="element-300" />
      </main>
      <Footer data-id="element-301" />
    </div>;
}